module.exports = __webpack_public_path__ + "img/noData.2bfae36f.svg";